import { render, staticRenderFns } from "./SaleContainersTable.vue?vue&type=template&id=46935c0a"
import script from "./SaleContainersTable.vue?vue&type=script&lang=js"
export * from "./SaleContainersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports